// components/bill-list/component
/* global DEBUG */

import template  from './component.jade'
import style    from './style.scss'
import Store     from 'Store'
import parseTime from 'lib/filters/parseUnixTime'
import billLink  from 'lib/filters/parseBillLink'
import cntLinks  from 'lib/filters/parseCntLinks'
import onClick   from 'lib/methods/onClick'

var name = 'zayavki-list';
var url = '/api/ZayavkiList';

const store = new Store(name);
const allowedLogins = [
    'admin'
];
let orders = {
    'transfer':
        [
            {text: 'Ускоренный контейнерный поезд ст. Базаиха', value: 'order-ukp-bazaiha'},
            {text: 'Ускоренный контейнерный поезд ст. Екатеринбург-товарный', value: 'order-ukp-ekat'},
            {text: 'Ускоренный контейнерный поезд ст. Клещиха', value: 'order-ukp-kleshiha'},
            {text: 'Ускоренный контейнерный поезд ст. Жигулевское море', value: 'order-ukp-zhigsea'},
            {text: 'Ускоренный контейнерный поезд Московский узел', value: 'order-ukp-moscow'},
            {text: 'Ускоренный контейнерный поезд ст. Базаиха в режиме ВТТ', value: 'order-vtt-bazaiha'},
            {text: 'Ускоренный контейнерный поезд ст. Ховрино в режиме ВТТ', value: 'order-vtt-hovrino'},
            {text: 'Ускоренный контейнерный поезд ст. Жигулевское море в режиме ВТТ', value: 'order-vtt-zhigsea'},
            {text: 'Повагонную отправку контейнера', value: 'order-normal'},
            {text: 'Выполнение терминальных работ', value: 'order-terminal'},
        ]
    ,
    'delivery':
        [
            {text: 'Завоз контейнера на терминал ПИК', value: 'auto-import'}]
};
let tableSort =function (a, b) {
    if (a.date > b.date)
        return -1;
    if (a.date < b.date)
        return 1;
    return 0;
};
export default {

  name: name,
    template: template({style: style}),
  props: ['table', 'title'],
  mixins: [parseTime, billLink, cntLinks, onClick],

  data: () => ({
    name: name,
    url: url,
    data: {},
    orders:orders['transfer'],
    buttonUrl:null,
    type: 'transfer',
      showDelivery:false
  }),
    ready(){
         let check;
         check = allowedLogins.indexOf(store.$get('login'));
        if (check !== -1) {
        }
         this.showDelivery = true;

    },
  events: {
    // при изменении дат, запросим список заявок
    ['dates:' + name]: function (data) {
      this.$set('data', null);
      this.$set('data', data);
      this.$set('data', store.$get(this));
      return false
    },
  },
    methods: {
      changeOrders(value){
         this.$set('type', value);
         this.$set('selectedOrder', '');
         return this.orders = orders [value] ;
      },
    },
    watch:{
        selectedOrder:function (e) {
          this.$set('buttonUrl', e);
      }
    },
    computed: {
        table() {
            this.data.table.sort(tableSort);
            return this.data.table
        },
    },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/zayavki-list/component.js
 **/